module.exports = __webpack_public_path__ + "static/media/LinkedIN.9c37e0dc.svg";